export default "__VITE_ASSET__DtZZmm1q__"